import { c as _c } from "react/compiler-runtime";
import { KeyValueGrid } from "@/components/domain/key-value-grid";
import { KeyValueSkeleton } from "@/components/domain/key-value-skeleton";
import { PillCountSkeleton } from "@/components/domain/pill-count";
import { ReportSection } from "@/components/domain/report-section";
import { sections } from "@/lib/constants/sections";
import { Skeleton } from "@domainstack/ui/skeleton";
export function SeoSectionSkeleton() {
  const $ = _c(14);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex items-center gap-2 text-[11px] leading-none tracking-[0.08em] text-foreground/70 uppercase dark:text-foreground/80">Meta Tags<PillCountSkeleton /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="space-y-3">{t0}<KeyValueGrid colsDesktop={2}><KeyValueSkeleton label="Title" widthClass="w-[220px]" /><KeyValueSkeleton label="Description" widthClass="w-[260px]" /><KeyValueSkeleton label="Canonical" widthClass="w-[200px]" /><KeyValueSkeleton label="Image" widthClass="w-[260px]" /></KeyValueGrid></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="text-[11px] tracking-[0.08em] text-foreground/70 uppercase dark:text-foreground/80">Open Graph</div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="flex h-11 w-full items-center gap-1 rounded-lg border border-black/8 bg-muted/40 p-1 backdrop-blur-sm dark:border-white/10">{[1, 2, 3, 4, 5].map(_temp)}</div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="aspect-[16/9] min-h-[160px] w-full"><Skeleton className="h-full w-full rounded-none" /></div>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="flex h-[1lh] items-center text-[11px]"><Skeleton className="h-[11px] w-24" /></div>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="flex h-[1lh] items-center text-[15px]"><Skeleton className="h-[15px] w-3/4" /></div>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="mt-6 space-y-3">{t2}{t3}<div className="mx-auto mt-4 mb-2 w-full max-w-[480px] md:max-w-[640px]"><div className="overflow-hidden rounded-2xl border border-border bg-background/60 backdrop-blur-lg">{t4}<div className="space-y-1.5 p-3">{t5}{t6}<div className="flex h-[1lh] items-center text-[13px]"><Skeleton className="h-[13px] w-full" /></div></div></div></div></div>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="mt-5 flex items-center gap-2 text-[11px] leading-none tracking-[0.08em] text-foreground/70 uppercase dark:text-foreground/80">robots.txt<PillCountSkeleton /></div>;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Skeleton className="h-9 w-full rounded-md sm:flex-1" />;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <div className="flex flex-col gap-2 sm:flex-row sm:items-center">{t9}<div className="flex h-9 w-full items-stretch gap-1 rounded-lg border border-black/8 bg-muted/50 p-1 sm:w-auto dark:border-white/10 [&>*]:flex-1 sm:[&>*]:flex-none"><Skeleton className="h-full rounded-md sm:w-[4.5rem]" /><Skeleton className="h-full rounded-md sm:w-[5.5rem]" /><Skeleton className="h-full rounded-md sm:w-[6.75rem]" /></div></div>;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <div className="space-y-2">{["g-0", "g-1", "g-2"].map(_temp2)}</div>;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  let t12;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <div className="mt-5 flex items-center gap-2 text-[11px] leading-none tracking-[0.08em] text-foreground/70 uppercase dark:text-foreground/80">Sitemaps<PillCountSkeleton /></div>;
    $[12] = t12;
  } else {
    t12 = $[12];
  }
  let t13;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <ReportSection isLoading={true} {...sections.seo}><div className="space-y-4">{t1}{t7}<div className="space-y-4 rounded-xl">{t8}{t10}{t11}<div className="space-y-3">{t12}<div className="flex flex-col gap-2.5">{["sm-0", "sm-1"].map(_temp3)}</div></div></div></div></ReportSection>;
    $[13] = t13;
  } else {
    t13 = $[13];
  }
  return t13;
}
function _temp3(sid) {
  return <Skeleton key={sid} className="h-[18px] w-56" />;
}
function _temp2(gid, gidx) {
  return <div key={gid}><div className="flex w-full items-center justify-between rounded-md px-2 py-2"><div className="flex flex-wrap items-center gap-1.5"><Skeleton className="h-5 w-25 rounded" /></div><Skeleton className="h-4 w-24" /></div>{gidx === 0 && <div className="flex flex-col py-2">{[0, 1, 2, 3, 4, 5].map(rid => <div key={`${gid}-rule-${rid}`} className={`flex items-center gap-2 border-t border-muted px-2.5 py-2.5 ${rid === 0 ? "border-t-0" : ""}`}><Skeleton className="size-4 rounded-full" /><Skeleton className="h-3 w-32 rounded" /></div>)}</div>}</div>;
}
function _temp(id) {
  return <Skeleton key={`og-tab-${id}`} className="h-full flex-1 basis-0 rounded-md" />;
}